import React, { ReactNode } from 'react';
import { useTemplates2Delete } from "@/lib/api/requests/templates.requests";
import { toast } from "@/lib/toast";
import { StandardDeleteDialog } from '@/util-components/dialog/StandardDeleteDialog';

interface DeleteTemplateDialogProps {
  /**
   * The trigger element that opens the dialog (optional)
   */
  trigger?: ReactNode;
  /**
   * Whether the dialog is open
   */
  open?: boolean;
  /**
   * Callback when dialog open state changes
   */
  onOpenChange?: (open: boolean) => void;
  /**
   * The ID of the template to delete
   */
  templateId: string;
  /**
   * The title of the template for display
   */
  templateTitle: string;
  /**
   * Callback function called after successful deletion
   */
  onSuccess: () => void;
}

/**
 * Dialog component for deleting templates
 */
export const DeleteTemplateDialog: React.FC<DeleteTemplateDialogProps> = ({
  trigger,
  open,
  onOpenChange,
  templateId,
  templateTitle,
  onSuccess,
}) => {
  // API hook for deletion
  const deleteMutation = useTemplates2Delete();

  const handleDelete = async () => {
    try {
      await deleteMutation.mutateAsync(templateId);
      
      // Success handling
      toast.success('Template erfolgreich gelöscht!', {
        description: `"${templateTitle}" wurde entfernt.`,
        duration: 3000,
      });
      
      onSuccess?.();
    } catch (error) {
      // Error handling
      console.error('Failed to delete template:', error);
      toast.error('Fehler beim Löschen', {
        description: 'Das Template konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
        duration: 5000,
        error,
      });
    }
  };

  return (
     <StandardDeleteDialog
       trigger={trigger}
       open={open}
       onOpenChange={onOpenChange}
       title="Template löschen"
       description="Diese Aktion kann nicht rückgängig gemacht werden"
       itemTitle={templateTitle}
       itemTypeLabel="Template ID"
       itemTypeValue={templateId}
       onDelete={handleDelete}
       isLoading={deleteMutation.isPending}
     />
  );
};
